import {
  _UByte___init__impl__g9hnc430zp6cgd9f0jq as _UByte___init__impl__g9hnc4,
  _UByte___get_data__impl__jof9qryxuf3cmdpzyk as _UByte___get_data__impl__jof9qr,
  UBytep4j7r1t64gz1 as UByte,
} from './UByte.mjs';
import { NoSuchElementException679xzhnp5bpj as NoSuchElementException } from './exceptions.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from './js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from './js/void.mjs';
import { contains1a3ax1gghv0nr as contains } from './collections/_Arrays.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from './hacks.mjs';
import {
  toString1pkumu07cwy4m as toString,
  hashCodeq5arwsb9dgti as hashCode,
  equals2au1ep9vhcato as equals,
} from './js/coreRuntime.mjs';
import { Collection1k04j3hzsbod0 as Collection } from './collections/Collections.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function _UByteArray___init__impl__ip4y9n(storage) {
  return storage;
}
function _UByteArray___get_storage__impl__d4kctt($this) {
  return $this;
}
function _UByteArray___init__impl__ip4y9n_0(size) {
  return _UByteArray___init__impl__ip4y9n(new Int8Array(size));
}
function UByteArray__get_impl_t5f3hv($this, index) {
  // Inline function 'kotlin.toUByte' call
  var this_0 = _UByteArray___get_storage__impl__d4kctt($this)[index];
  return _UByte___init__impl__g9hnc4(this_0);
}
function UByteArray__set_impl_jvcicn($this, index, value) {
  var tmp = _UByteArray___get_storage__impl__d4kctt($this);
  // Inline function 'kotlin.UByte.toByte' call
  tmp[index] = _UByte___get_data__impl__jof9qr(value);
}
function _UByteArray___get_size__impl__h6pkdv($this) {
  return _UByteArray___get_storage__impl__d4kctt($this).length;
}
function UByteArray__iterator_impl_509y1p($this) {
  return new (Iterator())(_UByteArray___get_storage__impl__d4kctt($this));
}
var IteratorClass;
function Iterator() {
  if (IteratorClass === VOID) {
    class $ {
      constructor(array) {
        this.cu_1 = array;
        this.du_1 = 0;
      }
      q1() {
        return this.du_1 < this.cu_1.length;
      }
      eu() {
        var tmp;
        if (this.du_1 < this.cu_1.length) {
          var _unary__edvuaz = this.du_1;
          this.du_1 = _unary__edvuaz + 1 | 0;
          // Inline function 'kotlin.toUByte' call
          var this_0 = this.cu_1[_unary__edvuaz];
          tmp = _UByte___init__impl__g9hnc4(this_0);
        } else {
          throw NoSuchElementException().a2(this.du_1.toString());
        }
        return tmp;
      }
      r1() {
        return new (UByte())(this.eu());
      }
    }
    initMetadataForClass($, 'Iterator');
    IteratorClass = $;
  }
  return IteratorClass;
}
function UByteArray__contains_impl_njh19q($this, element) {
  var tmp = _UByteArray___get_storage__impl__d4kctt($this);
  // Inline function 'kotlin.UByte.toByte' call
  var tmp$ret$0 = _UByte___get_data__impl__jof9qr(element);
  return contains(tmp, tmp$ret$0);
}
function UByteArray__contains_impl_njh19q_0($this, element) {
  if (!(element instanceof UByte()))
    return false;
  return UByteArray__contains_impl_njh19q($this.fu_1, element instanceof UByte() ? element.au_1 : THROW_CCE());
}
function UByteArray__isEmpty_impl_nbfqsa($this) {
  return _UByteArray___get_storage__impl__d4kctt($this).length === 0;
}
function UByteArray__toString_impl_ukpl97($this) {
  return 'UByteArray(storage=' + toString($this) + ')';
}
function UByteArray__hashCode_impl_ip8jx2($this) {
  return hashCode($this);
}
function UByteArray__equals_impl_roka4u($this, other) {
  if (!(other instanceof UByteArray()))
    return false;
  var tmp0_other_with_cast = other.fu_1;
  if (!equals($this, tmp0_other_with_cast))
    return false;
  return true;
}
var UByteArrayClass;
function UByteArray() {
  if (UByteArrayClass === VOID) {
    class $ {
      constructor(storage) {
        this.fu_1 = storage;
      }
      q2() {
        return _UByteArray___get_size__impl__h6pkdv(this.fu_1);
      }
      p1() {
        return UByteArray__iterator_impl_509y1p(this.fu_1);
      }
      gu(element) {
        return UByteArray__contains_impl_njh19q(this.fu_1, element);
      }
      t2(element) {
        return UByteArray__contains_impl_njh19q_0(this, element);
      }
      n1() {
        return UByteArray__isEmpty_impl_nbfqsa(this.fu_1);
      }
      toString() {
        return UByteArray__toString_impl_ukpl97(this.fu_1);
      }
      hashCode() {
        return UByteArray__hashCode_impl_ip8jx2(this.fu_1);
      }
      equals(other) {
        return UByteArray__equals_impl_roka4u(this.fu_1, other);
      }
    }
    initMetadataForClass($, 'UByteArray', VOID, VOID, [Collection()]);
    UByteArrayClass = $;
  }
  return UByteArrayClass;
}
//region block: exports
export {
  _UByteArray___init__impl__ip4y9n as _UByteArray___init__impl__ip4y9n15i9if485vlfd,
  _UByteArray___init__impl__ip4y9n_0 as _UByteArray___init__impl__ip4y9n1ymkr3h4vpfmg,
  UByteArray__get_impl_t5f3hv as UByteArray__get_impl_t5f3hvbbj411cc05mf,
  UByteArray__set_impl_jvcicn as UByteArray__set_impl_jvcicn2hmfyga0u5ve0,
  _UByteArray___get_size__impl__h6pkdv as _UByteArray___get_size__impl__h6pkdv2q8ncjn6v8oz0,
  _UByteArray___get_storage__impl__d4kctt as _UByteArray___get_storage__impl__d4kcttp6btvbau0f8b,
  UByteArray as UByteArray2qu4d6gwssdf9,
};
//endregion

//# sourceMappingURL=UByteArray.mjs.map
